import { Inject, Injectable } from '@angular/core';
import { RmService } from '@bidi/common-services';
import { createFeatureSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { State } from './ngrx/reducers';
import es from 'date-fns/locale/es';
import { format, parse } from 'date-fns';
import { GetCommentsResources } from './ngrx/actions';

@Injectable()
export class CommentsResourcesService {
  static featureName = '@bidi/common-components CommentsResources';

  constructor(private store: Store<any>, private rm: RmService) {}

  private state$: Observable<State> = this.store.pipe(
    select(createFeatureSelector(CommentsResourcesService.featureName))
  );

  comments$: Observable<any> = this.state$.pipe(select('comments'));
  loading$: Observable<any> = this.state$.pipe(select('loading'));

  getComments(id: string) {
    this.store.dispatch(new GetCommentsResources(id));
  }
}
